import CountryPageRenderer from '../components/CountryPageRenderer';
import thailandData from '../data/country-pages/thailand';

export default function ThailandCountryPage() {
  return <CountryPageRenderer data={thailandData} />;
}
